/*=========================================================================================
  File Name: modulePackageManagementState.js
  Description: Package Module State
==========================================================================================*/

export default {
    packages: [],
  }